import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiTypography from "@material-ui/core/Typography";
import classNames from "classnames";
export const Typography = props => {
  const {
    className,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiTypography, _extends({
    className: classNames(className, "prmbl-typography")
  }, otherProps));
};
Typography.defaultProps = {
  align: "inherit",
  color: "initial",
  gutterBottom: false,
  noWrap: false,
  paragraph: false,
  variant: "body1",
  display: "initial"
};
export default Typography;